import * as React from 'react';
import * as style from './AwardCard.css';
import { Image, UIText2, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IAwardCardProps {
  title: string;
  image: string;
}

export const AwardCard = ({ title, image }: IAwardCardProps) => {
  const deviceType = useDeviceType();

  const size = React.useMemo(() => {
    return deviceType === 'desktop' ? 80 : 66;
  }, [deviceType]);

  return (
    <div className={style['card']}>
      <div className={clsx(style['image'], deviceType === 'desktop' && style['image--desktop'])}>
        <Image src={image} alt={title} height={size} width={size} objectFit="contain" preloader={false} />
      </div>
      <UIText2>{title}</UIText2>
    </div>
  );
};
